// extracted by css-extract-rspack-plugin
export default {"pageNavigator":"pageNavigator-3nwEw","indicator":"indicator-3_ET1"};